import React, { Fragment, useEffect, useState } from "react";
import Container from "@/components/container/Container";
import CardComponent from "@/components/card";

import "@/styles/session/my-session.scss";
import { Col, Flex, Row } from "antd";
import IconSessionName from "@/components/icons/IconSessionName";
import IconCalender from "@/components/icons/IconCalender";
import IconSessionTime from "@/components/icons/IconSessionTime";
import IconDuration from "@/components/icons/IconDuration";
import IconUserProfile from "@/components/icons/IconUserProfile";
import ButtonComponent from "@/components/button/Button";
import IconSession from "@/components/icons/IconSession";
import BackWithLabel from "@/components/common/BackWithLabel";
import { useNavigate } from "react-router-dom";
import { getBookedSessions } from "@/services/users/getBookedSessions";
import Session from "@/pages/session/Session";
import IconAddExpert from "@/components/icons/IconAddExpert";
import useTriggerNotification from "@/hooks/useTriggerNotification";
import { convertToLocalTime } from "@/helpers";
import { getCountryTimeZone } from "@/helpers/getCountryZone";
import IconReschedule from "@/components/icons/IconReshedule";
import { useDispatch } from "react-redux";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { setCurrentGuide } from "@/reducers/guideSlice";
import { isWithin24Hours } from "@/pages/session/sessionUtils";
import { getGuideProfile } from "@/services/guides/getGuideProfile";
import moment from "moment";
import { rescheduleSession } from "@/services/students/session";
import { showNotification } from "@/components/toaster/Toaster";

const MySession = () => {
  const [id, setId] = useState("");
  const navigate = useNavigate();
  const { trigger, element } = useTriggerNotification();
  const [sessionData, setSessionData] = useState([]);
  const [timezone, setTimezone] = useState();
  const dispatch = useDispatch();

  const fetchData = () => {
    // getMeetingLink()
    //   .then((res) => setId(res[0].code))
    //   .catch((err) => console.log(err));
    getBookedSessions()
      .then((res) => {
        const responseClone = [...res];
        const updatedData = responseClone?.map((x) => {
          return {
            ...x,
            ...convertToLocalTime(x.date, x.time),
          };
        });
        setSessionData([...updatedData]);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCopyToClipboard = (id) => {
    const path = window.location.origin + "/parent/lobby/" + id;
    navigator.clipboard.writeText(path).then(() => {
      trigger({
        type: "success",
        message: "Link Copied to Clipboard",
      });
    });
  };

  const handleRescheduleSession = async (sessionItem) => {
    console.log("sessionItem", sessionItem);
    const guideData = await getGuideProfile(sessionItem.guideId);
    if (isWithin24Hours(sessionItem)) {
      console.log("Cannot reschedule session");
      dispatch(setCurrentForm("requestWithReason"));
      dispatch(setModalOpen(true));
      dispatch(
        setFormProps({
          message: "Are you sure you want to request a session reschedule?",
          onSubmit: (data) => {
            console.log("data", data);
            const payload = {
              reason: data.comment,
              bookingId: sessionItem.id,
            };
            rescheduleSession(payload)
              .then((res) => {
                console.log("reschedule request registered", res);
                fetchData();
                showNotification(
                  "success",
                  "Registered!",
                  "Your reschedule request has been registered."
                );
              })
              .catch((err) => console.log(err));
            dispatch(setModalOpen(false));
          },
        })
      );
    } else {
      dispatch(setCurrentForm("bookASession"));
      dispatch(
        setFormProps({
          selectedDateProp: moment(sessionItem.date),
          durationProp: sessionItem.duration === 30 ? "30min" : "60min",
          isUpdate: true,
          handleUpdateSession: async (data) => {
            const payload = {
              date: moment(data.date).format("YYYY-MM-DD"),
              bookingId: sessionItem.id,
              timeslots: data.time.map((x) => {
                return {
                  start: x.start,
                  end: x.end,
                };
              }),
            };
            console.log("data to be updated", data);
            rescheduleSession(payload)
              .then((res) => {
                console.log("reschedule done", res);
                fetchData();
                showNotification("success", "Rescheduled!", "Your session has been rescheduled.");
              })
              .catch((err) => console.log(err));
          },
        })
      );
      dispatch(setCurrentGuide(guideData));
      dispatch(setModalOpen(true));
    }
  };
  const handleJoinSession = (id) => {
    navigate(`/lobby/${id}`);
    // axiosInstance
    //   .get("https://dull-rings-invent.loca.lt/api/v0/common/test", {
    //     headers: {
    //       "bypass-tunnel-reminder": "Okay",
    //     },
    //   })
    //   .then((res) => {
    //     navigate(`/sessions/${res.data.roomCode}`);
    //   });
    // getRoomCodeBySession(id)
    //   .then((res) => {
    //     if (res.roomCode) {
    //       navigate(`/sessions/${res.roomCode}`);
    //     }
    //   })
    //   .catch((err) => console.log(err));
  };

  useEffect(() => {
    setTimezone(getCountryTimeZone());
  }, []);

  return (
    <Fragment>
      {element}
      <div className="my-session-wrapper">
        <Container>
          <CardComponent>
            <div className="heading">
              <BackWithLabel label="My Sessions" />
            </div>
            {!sessionData?.length ? (
              <Session />
            ) : (
              <div className="sessions">
                <Row gutter={[16, 16]}>
                  {sessionData.map((item, index) => {
                    return (
                      <Col xxl={8} xl={8} lg={12} md={24} sm={24} xs={24} key={index}>
                        <div className="session-outer-card">
                          <CardComponent>
                            <div className="session-inner-card">
                              <CardComponent>
                                {/* <div className="heading title-h5-1">
                                  My Upcoming Session
                                </div>

                                <Divider /> */}

                                <Flex gap="5px" className="sesstion-name">
                                  <IconSessionName />
                                  {/* <span>Session Name:</span> */}
                                  {item.name}
                                </Flex>

                                <Flex gap="5px" className="session-date">
                                  <IconCalender />
                                  <span>Date:</span>
                                  {item.date}
                                </Flex>

                                <Flex gap="5px" className="session-time">
                                  <IconSessionTime />
                                  <span>Time:</span>
                                  {item.time} {timezone ? `(${timezone})` : ""}
                                </Flex>

                                <Flex gap="5px" className="session-duration">
                                  <IconDuration />
                                  <span>Duration:</span>
                                  {item.duration} Minutes
                                </Flex>

                                <Flex gap="5px" className="guide-name">
                                  <IconUserProfile />
                                  <span>Mentor:</span>
                                  {item.guideName}
                                </Flex>

                                <div className="session-button">
                                  <ButtonComponent
                                    varient="primary"
                                    label="Join Session"
                                    iconRight={false}
                                    onClick={() => handleJoinSession(item.id)}
                                  >
                                    <IconSession width="24px" height="24px" color="#fdfefe" />
                                  </ButtonComponent>
                                </div>
                                <div className="session-button">
                                  <ButtonComponent
                                    label="Invite Parents"
                                    iconRight={false}
                                    onClick={() => handleCopyToClipboard(item.id)}
                                  >
                                    <IconAddExpert width="24px" height="24px" color="#db5800" />
                                  </ButtonComponent>
                                </div>
                                <div className="session-button">
                                  <ButtonComponent
                                    label="Reschedule Session"
                                    iconRight={false}
                                    onClick={() => handleRescheduleSession(item)}
                                  >
                                    <IconReschedule width="24px" height="24px" color="#db5800" />
                                  </ButtonComponent>
                                </div>
                              </CardComponent>
                            </div>
                          </CardComponent>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            )}
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default MySession;
